module.exports = __webpack_public_path__ + "static/media/iskald.147b958b.m4a";